//import HttpRequest from '../utils/HttpRequest.js';
import HttpRequest from 'helper-xhr';
import { debounce } from "../utils/debounce.js";

import {
  PUSH_ITEM, PUSH_ITEM_REMOTELY, PUSH_ITEM_REMOTELY_FAILURE, PUSH_ITEM_REMOTELY_SUCCESS,
  GET_CART_FAIL, GET_CART_SUCCESS,
  ADD_CART_TO_CLOSED,
  UPDATE_UI,
  CART_IS_LOADING
} from "./action-types.js";

export const pushItemLocally = item => ({ type: PUSH_ITEM, item: item });
export const pushItemRemotely = item => ({ type: PUSH_ITEM_REMOTELY, payload: item });
export const pushItemRemotely_FAIL = item => ({ type: PUSH_ITEM_REMOTELY_FAILURE, error: "Oops..." });
//export const pushItemRemotely_SUCCESS = items => ({ type: PUSH_ITEM_REMOTELY_SUCCESS, payload: items });

//export const getCart = cart => ({ type: GET_CART, cart: cart });
export const getCart_FAIL = error => ({ type: GET_CART_FAIL, error: error });
export const getCart_SUCCESS = cart => ({ type: GET_CART_SUCCESS, cart: cart });

export const addCartToClosed = cart => ({ type: ADD_CART_TO_CLOSED, cart: cart });

export const updateUI = ui => ({ type: UPDATE_UI, ui: ui });
export const cartIsLoading = isLoading => ({ type: CART_IS_LOADING, isLoading: isLoading });

//test test

const updateItemData = (item) => {
  return (dispatch) => {
    dispatch(cartIsLoading(true));
    var segment = "item-update";
    if (item.spareid) {
      segment = "spare-update";
    } else if (item.wheelid) {
      segment = "wheel-update";
    } else if (item.productid) {
      segment = "product-update";
    }
    var xhr = new HttpRequest("POST", '/ajax/cart/' + segment, "application/json");
    return xhr.send(item)
      .then((response) => {
        var json = response.json;
        if (json.message || json.exception || json.error) {
          dispatch(getCart_FAIL(e));
        }

        let price = null;
        let items = [];

        if (segment == "item-update") {
          price = item.GATRAI.replace(",", ".") * item.qty_change; // item.prices.bestprice.raw * item.qty_change;

          items.push({
            item_id: item.UniqueTireID,
            item_name: item.Brand + " " + item.Pattern + " " + item.Season,
            item_variant: item.Width + "/" + item.Ratio + " " + item.Diameter + " " + item.Load + " " + item.Speed,
            googleId: item.hash,
            currency: "EUR",
            price: item.GATRAI.replace(",", "."),
            bestprice: item.prices.bestprice.raw,
            GATRAI: item.GATRAI.replace(",", "."),
            quantity: item.qty_change,
            item_brand: item.Brand,
            index: 0,
            item_category: "tire"
          });

          //var fittingGroup = ((((json || {}).order || {}).json || {}).fittingGroups || []).find(fitting => fitting.selected && fitting.itemid == item.itemid);

          //if (fittingGroup != null) {
          //  var wheelFitting = ((json || {}).wheels || []).find(wheelFitting => wheelFitting.itemid == fittingGroup.wheelid);

          //  if ((wheelFitting != null) && (wheelFitting.qty != item.qty)) {
          //    price = wheelFitting.GATRAI.replace(",", ".") * item.qty_change // item.prices.bestprice.raw * item.qty_change;

          //    items.push({
          //      item_id: wheelFitting.wheelid.trim(),
          //      item_name: wheelFitting.details.Brand + " " + wheelFitting.details.Model,
          //      item_variant: wheelFitting.details.Color + " " + wheelFitting.details.Holes + " fori",
          //      googleId: wheelFitting.googleId,
          //      currency: "EUR",
          //      price: wheelFitting.GATRAI.replace(",", "."),
          //      bestprice: wheelFitting.prices.bestprice.raw,
          //      GATRAI: wheelFitting.GATRAI.replace(",", "."),
          //      quantity: item.qty_change,
          //      item_brand: wheelFitting.details.Brand,
          //      index: 0,
          //      item_category: "wheel"
          //    });
          //  }
          //}
        }
        else if (segment == "wheel-update") {
          price = item.GATRAI.replace(",", ".") * item.qty_change // item.prices.bestprice.raw * item.qty_change;

          items.push({
            item_id: item.wheelid.trim(),
            item_name: item.details.Brand + " " + item.details.Model,
            item_variant: item.details.Color + " " + item.details.Holes + " fori",
            googleId: item.googleId,
            currency: "EUR",
            price: item.GATRAI.replace(",", "."),
            bestprice: item.prices.bestprice.raw,
            GATRAI: item.GATRAI.replace(",", "."),
            quantity: item.qty_change,
            item_brand: item.details.Brand,
            index: 0,
            item_category: "wheel"
          });

          //var fittingGroup = ((((json || {}).order || {}).json || {}).fittingGroups || []).find(fitting => fitting.selected && fitting.wheelid == item.itemid);

          //if (fittingGroup != null) {
          //  var itemFitting = ((json || {}).items || []).find(itemFitting => itemFitting.itemid == fittingGroup.itemid);

          //  if ((itemFitting != null) && (itemFitting.qty != item.qty)) {
          //    price = item.GATRAI.replace(",", ".") * item.qty_change; // item.prices.bestprice.raw * item.qty_change;

          //    items.push({
          //      item_id: itemFitting.UniqueTireID,
          //      item_name: itemFitting.Brand + " " + itemFitting.Pattern + " " + itemFitting.Season,
          //      item_variant: itemFitting.Width + "/" + itemFitting.Ratio + " " + itemFitting.Diameter + " " + itemFitting.Load + " " + itemFitting.Speed,
          //      googleId: itemFitting.hash,
          //      currency: "EUR",
          //      price: itemFitting.GATRAI.replace(",", "."),
          //      bestprice: itemFitting.prices.bestprice.raw,
          //      GATRAI: itemFitting.GATRAI.replace(",", "."),
          //      quantity: item.qty_change,
          //      item_brand: itemFitting.Brand,
          //      index: 0,
          //      item_category: "tire"
          //    });
          //  }
          //}
        }
        else if (segment == "spare-update") {
          price = item.GATRAI.replace(",", ".") * item.qty_change; // item.prices.bestprice.raw * item.qty_change;

          items.push({
            item_id: item.spareid.trim(),
            item_name: "RUOTINO DI SCORTA " + (item.details.isFerro ? "IN FERRO" : "IN LEGA") + " per " + item.details.ManufacturerName + " " + item.details.ModelName + " " + item.details.year,
            item_variant: item.details.description + " " + item.details.nnhh + " fori",
            googleId: item.googleId,
            currency: "EUR",
            price: item.GATRAI.replace(",", "."),
            bestprice: item.prices.bestprice.raw,
            GATRAI: item.GATRAI.replace(",", "."),
            quantity: item.qty_change,
            index: 0,
            item_category: "spare"
          });
        }

        if (items.length > 0) {
          var siteGTag = window.site_config.gtag;

          var event = "add_to_cart";

          if ((item.qty == 0) || (item.qty_change < 0)) {
            event = "remove_from_cart";

            gtag("event", event, {
              // send_to: siteGTag.GA4IDAnalytics,
              ecommerce: {
                currency: "EUR",
                value: price,
                total_bestprice: (json.totals || { totalToPay: { raw: 0 } }).totalToPay.raw,
                items: items.map((e) => {
                  return {
                    item_id: e.googleId,
                    item_name: e.item_name,
                    item_variant: e.item_variant,
                    currency: "EUR",
                    price: parseFloat(e.GATRAI),
                    bestprice: e.bestprice,
                    quantity: e.quantity,
                    index: e.index,
                    item_category: e.item_category,
                    item_brand: e.item_brand
                  };
                })
              }
            });

            //gtag("event", event, {
            //  send_to: siteGTag.UIDAnalytics,
            //  items: items.map((e) => {
            //    return {
            //      id: e.googleId,
            //      name: e.item_name,
            //      variant: e.item_variant,
            //      brand: e.item_brand,
            //      price: e.GATRAI,
            //      category: e.item_category,
            //      quantity: e.quantity,
            //      list_name: "Cart",
            //      list_position: e.index
            //    };
            //  })
            //});
          }
          else {
            gtag("event", event, {
              // send_to: siteGTag.GA4IDAnalytics,
              ecommerce: {
                currency: "EUR",
                value: price,
                total_bestprice: (json.totals || { totalToPay: { raw: 0 } }).totalToPay.raw,
                items: items.map((e) => {
                  return {
                    item_id: e.googleId,
                    item_name: e.item_name,
                    item_variant: e.item_variant,
                    currency: "EUR",
                    price: parseFloat(e.GATRAI),
                    bestprice: e.bestprice,
                    quantity: e.quantity,
                    index: e.index,
                    item_category: e.item_category,
                    item_brand: e.item_brand
                  };
                }),
              }
            });

            //gtag("event", event, {
            //  send_to: siteGTag.UIDAnalytics,
            //  items: items.map((e) => {
            //    return {
            //      id: e.googleId,
            //      name: e.item_name,
            //      variant: e.item_variant,
            //      brand: e.item_brand,
            //      price: e.GATRAI,
            //      category: e.item_category,
            //      quantity: e.quantity,
            //      list_name: "Cart",
            //      list_position: e.index
            //    };
            //  })
            //});
          }

          //gtag({
          //  send_to: siteGTag.UIDAnalytics,
          //  event: "remove_from_cart", // "removeFromCart",
          //  ecommerce: {
          //    remove: {
          //      products: items.map((e) => {
          //        return {
          //          id: e.item_id,
          //          name: e.item_name,
          //          variant: e.item_variant,
          //          brand: e.item_brand,
          //          price: e.GATRAI,
          //          category: e.item_category,
          //          quantity: e.quantity
          //        };
          //      })
          //    }
          //  }
          //});

          //gtag("event", "remove_from_cart", {
          //  items: items.map((e) => {
          //    return {
          //      id: e.item_id,
          //      name: e.item_name,
          //      variant: e.item_variant,
          //      brand: e.item_brand,
          //      price: e.GATRAI,
          //      quantity: e.quantity,
          //      category: e.category
          //    };
          //  })
          //});
        }

        //dispatch(cartIsLoading(false));
        dispatch(getCart_SUCCESS(json))
      }, (error) => {
        console.log(error);
        dispatch(getCart_FAIL(error));
      });
  };
}

const pushItemData = (item, extra) => {
  return (dispatch) => {
    dispatch(cartIsLoading(true));
    var segment = "tire";
    if (item.segment) {
      segment = item.segment;
    } else if (item.cai) {
      segment = "tire";
    } else if (item.SpareId) {
      segment = "spare";
    } else if (item.Holes && item.Color) {
      segment = "wheel";
    }
    var xhr = new HttpRequest("POST", '/ajax/cart/push/' + segment, "application/json");
    return xhr.send(item)
      .then((response) => {
        var json = response.json;
        if (json.message || json.exception || json.error) {
          dispatch(getCart_FAIL(e));
        }

        var items = [];
        var price = null;
        var list_name = null;

        if ((segment == "wheel") && json.wheels) {
          let w_wheel = json.wheels.find(e => e.wheelid.trim() == item.WheelId.trim());

          if (w_wheel != null) {
            price = w_wheel.GATRAI.replace(",", ".") * w_wheel.qty; // w_wheel.prices.bestprice.raw * w_wheel.qty;
            list_name = "Wheel";

            items = [
              {
                item_id: w_wheel.wheelid.trim(),
                item_name: w_wheel.details.Brand + " " + w_wheel.details.Model,
                item_variant: w_wheel.details.Color + " " + w_wheel.details.Holes + " fori",
                googleId: w_wheel.googleId,
                currency: "EUR",
                price: w_wheel.GATRAI.replace(",", "."),
                bestprice: w_wheel.prices.bestprice.raw,
                GATRAI: w_wheel.GATRAI.replace(",", "."),
                quantity: w_wheel.qty,
                item_brand: w_wheel.details.Brand,
                index: 0,
                item_category: "wheel"
              }
            ];
          }
        }
        else if ((segment == "spare") && json.wheels) {
          let w_wheel = json.wheels.find(e => e.wheelid.trim() == item.SpareId.trim());

          if (w_wheel != null) {
            price = w_wheel.GATRAI.replace(",", ".") * w_wheel.qty; // w_wheel.prices.bestprice.raw * w_wheel.qty;
            list_name = "Spare";

            items = [
              {
                item_id: w_wheel.wheelid.trim(),
                item_name: "RUOTINO DI SCORTA " + (w_wheel.details.isFerro ? "IN FERRO" : "IN LEGA") + " per " + w_wheel.details.ManufacturerName + " " + w_wheel.details.ModelName + " " + w_wheel.details.year,
                item_variant: w_wheel.details.description + " " + w_wheel.details.nnhh + " fori",
                googleId: w_wheel.googleId,
                currency: "EUR",
                price: w_wheel.GATRAI.replace(",", "."),
                bestprice: w_wheel.prices.bestprice.raw,
                GATRAI: w_wheel.GATRAI.replace(",", "."),
                quantity: w_wheel.qty,
                index: 0,
                item_category: "spare"
              }
            ];
          }
        }
        else if ((segment == "tire") && json.items) {
          let t_tire = json.items.find(e => (e.UniqueTireID == item.uniquetireid));

          if (t_tire != null) {
            price = t_tire.GATRAI.replace(",", ".") * t_tire.qty; // t_tire.prices.bestprice.raw * t_tire.qty;
            list_name = "Tire";

            items = [
              {
                item_id: t_tire.UniqueTireID,
                item_name: t_tire.Brand + " " + t_tire.Pattern + " " + t_tire.Season,
                item_variant: t_tire.Width + "/" + t_tire.Ratio + " " + t_tire.Diameter + " " + t_tire.Load + " " + t_tire.Speed,
                googleId: t_tire.hash,
                currency: "EUR",
                price: t_tire.GATRAI.replace(",", "."),
                bestprice: t_tire.prices.bestprice.raw,
                GATRAI: t_tire.GATRAI.replace(",", "."),
                quantity: t_tire.qty,
                item_brand: t_tire.Brand,
                index: 0,
                item_category: "tire"
              }
            ];
          }
        }
        else if ((segment == "kit") && json.wheels && json.items) {
          let k_wheel = json.wheels.find(e => (e.details.Brand == item.Brand) && (e.details.Model == item.Model) && (e.details.Color == item.Color) && (e.details.Diameter == item.Diameter) && (e.details.Holes == item.Holes));
          let k_tire = json.items.find(e => e.UniqueTireID == item.uniquetireid);
          // let k_fitting = json.wheelFittingFees.find(e => e.diameter == item.Diameter);

          if ((k_tire != null) && (k_wheel != null)) {
            price = (0 + k_wheel.GATRAI.replace(",", ".") + k_tire.GATRAI.replace(",", ".")) * k_tire.qty; // (k_wheel.prices.bestprice.raw + k_tire.prices.bestprice.raw) * k_tire.qty;
            list_name = "Kit";

            items = [
              {
                item_id: k_wheel.wheelid.trim(),
                item_name: k_wheel.details.Brand + " " + k_wheel.details.Model,
                item_variant: k_wheel.details.Color + " " + k_wheel.details.Holes + " fori",
                googleId: k_wheel.googleId,
                currency: "EUR",
                price: k_wheel.GATRAI.replace(",", "."),
                bestprice: k_wheel.prices.bestprice.raw,
                GATRAI: k_wheel.GATRAI.replace(",", "."),
                quantity: k_wheel.qty,
                item_brand: k_wheel.details.Brand,
                index: 0,
                item_category: "wheel"
              },
              {
                item_id: k_tire.UniqueTireID,
                item_name: k_tire.Brand + " " + k_tire.Pattern + " " + k_tire.Season,
                item_variant: k_tire.Width + "/" + k_tire.Ratio + " " + k_tire.Diameter + " " + k_tire.Load + " " + k_tire.Speed,
                googleId: k_tire.hash,
                currency: "EUR",
                price: k_tire.GATRAI.replace(",", "."),
                bestprice: k_tire.prices.bestprice.raw,
                GATRAI: k_tire.GATRAI.replace(",", "."),
                quantity: k_tire.qty,
                item_brand: k_tire.Brand,
                index: 0,
                item_category: "tire"
              }
            ];
          }
        }

        if (items.length > 0) {
          var siteGTag = window.site_config.gtag;

          gtag("event", "add_to_cart", {
            // send_to: siteGTag.GA4IDAnalytics,
            ecommerce: {
              currency: "EUR",
              value: price,
              total_bestprice: json.totals.totalToPay.raw,
              items: items.map((e) => {
                return {
                  item_id: e.googleId,
                  item_name: e.item_name,
                  item_variant: e.item_variant,
                  currency: "EUR",
                  price: parseFloat(e.GATRAI),
                  bestprice: e.bestprice,
                  quantity: e.quantity,
                  index: e.index,
                  item_category: e.item_category,
                  item_brand: e.item_brand
                };
              })
            }
          });

          //gtag("event", "add_to_cart", {
          //  send_to: siteGTag.UIDAnalytics,
          //  items: items.map((e) => {
          //    return {
          //      id: e.googleId,
          //      name: e.item_name,
          //      variant: e.item_variant,
          //      brand: e.item_brand,
          //      price: e.GATRAI,
          //      quantity: e.quantity,
          //      category: e.item_category,
          //      list_name: list_name,
          //      list_position: e.index
          //    };
          //  })
          //});

          //gtag({
          //  send_to: siteGTag.UIDAnalytics,
          //  event: "add_to_cart", // "addToCart",
          //  ecommerce: {
          //    currencyCode: 'EUR',
          //    add: {
          //      products: items.map((e) => {
          //        return {
          //          id: e.item_id,
          //          name: e.item_name,
          //          variant: e.item_variant,
          //          brand: e.item_brand,
          //          price: e.GATRAI,
          //          category: e.item_category,
          //          quantity: e.quantity
          //        };
          //      })
          //    }
          //  }
          //});
        }

        //dispatch(cartIsLoading(false));
        //console.log("going to dispatch getCart_SUCCESS", { ...json });
        dispatch(getCart_SUCCESS(json))
        return response;
      }, (error) => {
        dispatch(cartIsLoading(false));
        dispatch(getCart_FAIL(error));
      });
  };
}

const updateCartData = (payload, action) => {
  if (!action) {
    action = "update";
  }
  if (payload && payload.order && payload.order.json) {
    //json key is too complex, it's breaking parsing server side
    payload.order.json = null;
  }
  return (dispatch) => {
    dispatch(cartIsLoading(true));
    var xhr = new HttpRequest("POST", '/ajax/cart/' + action, "application/json");
    return xhr.send(payload)
      .then((response) => {
        var json = response.json;
        if (json.message || json.exception || json.error) {
          dispatch(getCart_FAIL(e));
        }
        //dispatch(cartIsLoading(false));
        dispatch(getCart_SUCCESS(json))
        return response;
      }, (error) => {
        dispatch(getCart_FAIL(error));
      });
  };
}

const cartFetchData = () => {
  return (dispatch) => {
    //we should check if is already loading
    dispatch(cartIsLoading(true));
    let now = new Date();
    // facciamo così la chiamata per evitare il caching di IE11
    var xhr = new HttpRequest("GET", '/ajax/cart/get?date=' + ("0" + now.getDate()).slice(-2) + ("0" + (now.getMonth() + 1)).slice(-2) + now.getFullYear() + ("0" + now.getHours()).slice(-2) + ("0" + now.getMinutes()).slice(-2) + ("0" + now.getSeconds()).slice(-2) + ("00" + now.getMilliseconds()).slice(-3), "application/json");
    return xhr.send({})
      .then((response) => {
        var json = response.json;
        if (json.message || json.exception || json.error) {
          dispatch(getCart_FAIL(json.message || json.exception || json.error));
          //throw Error(json.message || json.exception || json.error);
        }
        //dispatch(cartIsLoading(false));
        //console.log("dispatch getCart_SUCCESS", json);
        dispatch(getCart_SUCCESS(json))
        return response;
      }, (error) => {
        dispatch(cartIsLoading(false));
        dispatch(getCart_FAIL(error));
      });
  };
}

export const getCart = () => (dispatch, getState) => {
  return dispatch(cartFetchData())
}

export const updateCart = (payload, action) => (dispatch, getState) => {
  return dispatch(updateCartData(payload, action))
}
export const pushItem = (item, extra) => (dispatch, getState) => {
  //dispatch(pushItemLocally(item));
  return dispatch(pushItemData(item,extra))
}
export const updateItem = (item) => (dispatch, getState) => {
  //dispatch(updateItemLocally(item));
  return dispatch(updateItemData(item))
}